export default __webpack_public_path__ + "static/media/person_gray.3287156d.svg";